// extracted by mini-css-extract-plugin
export var borderRadius = "_gv-4";
export var large = "_gv-3";
export var logoContainer = "_gv-0";
export var nameLogo = "_gv-2";
export var small = "_gv-1";